import generateHtml from "./generate-html";
import CreateListing from "../create-listing/create-listing";
// import startUp from "../main-start-up-screen/start-up.js";

// import DisplayListing from "../display-listing/display-listing";
// import Register from "../register/register.js";
import firebase from "../firebase.js";
// import handleAccount from "../register/handle-account.js";

import AllDisplaysInitial from "../handeling-all-displays/all-handeling.js";
import search from "../search/search.js";
import GENRALHELPERS from "../GENRAL-HELPERS.js";
import accountProfileChange from "../main-menu/account-profile-change.js";
import help from "../help/help.js";
import nav from "./nav.js";
import allHandeling from "../handeling-all-displays/all-handeling.js";
import signUpProfile from "../sign-up_profile/signUpProfile.js";
import businessPageEditor from "../business-page-editor/business-page-editor.js";
import NVBusinessEditor from "../business-page-editor/NV-business-editor.js";
import saved from "../saved-and-Followed/saved.js";
import adds from "../adds/adds.js";


import displayListingGenerateHtml from "../display-listing/generate-html";
import maiTips from "../mai-tips/mai-tips.js";
import createListing from "../create-listing/create-listing";



const omittedWords = ["for", "a", "the", "and"];


// TODO these should be replaced with dinamic loaded adds for Production
const topAdds = [
  {
    id: 'ucibo3jbedcib3rend',
    title: { text: "Hasta 35% OFF", color: '#fff' },
    description: { text: "Ofertas en Mercado Libre", color: '#fff' },
    ctaText: { text: "¡No te lo pierdas!", color: '#fff' },
    items: [
      { imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%20for%20test%2FIMG_1815.jpg?alt=media&token=ed4853d1-28e1-4c99-a037-020cfa950a2d', text: 'VICTUS', openLink: 'https://meli.la/2KGtT8T' },
      { imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%20for%20test%2FIMG_1816.jpg?alt=media&token=bdf0b9a7-f9ae-40df-8020-be44d682b22f', text: 'VICTUS', openLink: 'https://meli.la/1MZyFkf' },
      { imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%20for%20test%2FIMG_1817.jpg?alt=media&token=cb8381c4-9d02-4ab9-a13d-837e53bddf1d', text: 'Laptop Hp', openLink: 'https://meli.la/2Z4aAHh' },
      { imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%20for%20test%2FIMG_1818.jpg?alt=media&token=630c4c5d-e4cd-4bee-9fa2-c4dc841d98d7', text: 'Laptop Acer Nitro', openLink: 'https://meli.la/1tDLr6D' },
    ],
    gradient: {
      type: "linear",
      angle: 135,
      stops: [
        { color: "#F6E27A", pos: 0 },
        { color: "#D4AF37", pos: 45 },
        { color: "#B8962E", pos: 100 }
      ]
    },
    openLink: 'https://meli.la/263CnVV',
    button: { text: 'Ver Lista', textColor: '#000', buttonColor: '#ffffff' },
  }, {
    id: 'ucibo3jbedcib3rend',
    title: { text: "iPhone ofertas", color: '#fff' },
    description: { text: "¡Encuentra el tuyo!", color: '#fff' },
    ctaText: { text: "Compra en Mercado Libre", color: '#fff' },
    items: [
      { imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%20for%20test%2FIMG_1820.jpg?alt=media&token=4e250ec0-4fbb-4edc-b0cf-4c1418e64591', text: 'iPhone 16e', openLink: 'https://meli.la/2n8bHCj' },
      { imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%20for%20test%2FIMG_1822.jpg?alt=media&token=c8f71b94-6e46-4141-8537-608554ee7942', text: 'iPhone 17 Pro Max', openLink: 'https://meli.la/2g4qa4g' },
      { imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%20for%20test%2FIMG_1823.jpg?alt=media&token=b22aa44f-c05f-4c0d-b8ee-4389d0df1e15', text: 'iPhone 15', openLink: 'https://meli.la/2j9dyrD' },
      { imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%20for%20test%2FIMG_1824.jpg?alt=media&token=bd3b518b-58e1-488e-b9c3-4631fed3a498', text: 'iPhone 16 Plus', openLink: 'https://meli.la/2ovmCEn' },
    ],
    gradient: {
      type: "linear",
      angle: 135,
      stops: [
        { color: "#000000", pos: 0 },
        { color: "#000000", pos: 45 },
        { color: "#000000", pos: 100 }
      ]
    },
    openLink: 'https://meli.la/2xPumY8',
    button: { text: 'Ver Lista', textColor: '#000', buttonColor: '#ffffff' },
  },
]





class HomeScreen {
  #accountState;
  #alreadlyInitialized;
  #locationFilterTrigerFunctions = null

  #listingsLastVisDoc = null
  #allListingsLoaded = false
  #detectBottomScrollListingnsOn = false
  #isDoneLoadingListings = true
  #isInitScreen = true


  selectedLocationForFilter = {}

  #locationDataForFilter = {
    lat: null,
    lng: null,
    radius: 10
  }


  constructor() {
  }

  async _try() {
    const foundTargetedListings = await firebase._globalTargetedSearch(
      "sembradora"
    );
    console.log(foundTargetedListings);
  }

  async _populateMachineDataInFireBase() {
    setTimeout(async () => {
      await firebase._storeMachineData("trilladora", "john-deere", "7721");
    }, 5000);
  }

  _observeElementTopVisibility(targetId, callback) {
    const el = document.getElementById(targetId);
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // 👇 element is visible in viewport
          if (entry.isIntersecting) {
            if (!this.#isInitScreen) return
            callback(true, entry);
          } else {
            if (!this.#isInitScreen) return
            // 👇 element is out of view (top or bottom)
            callback(false, entry);
          }
        });
      },
      {
        root: null,        // viewport
        threshold: 0,      // trigger as soon as it enters/leaves
      }
    );

    observer.observe(el);

    return observer; // optional if you want to disconnect later
  }

  _detectScrollActivity(containerId, onScrollStart, onScrollStop, delay = 150) {
    const el = document.getElementById(containerId);
    if (!el) return;

    let scrollTimeout = null;
    let isScrolling = false;

    el.addEventListener("scroll", () => {
      // 🔥 SCROLL START
      if (!isScrolling) {
        isScrolling = true;
        onScrollStart?.();
      }

      // reset timer every scroll event
      clearTimeout(scrollTimeout);

      // 🛑 SCROLL STOP (after delay)
      scrollTimeout = setTimeout(() => {
        isScrolling = false;
        onScrollStop?.();
      }, delay);
    });
  }

  _scrollToTop(containerId) {
    const el = document.getElementById(containerId);
    if (!el) return;

    el.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }


  async _handleSelectLocationForFilter() {
    try {
      const locationData = await GENRALHELPERS._locationPicker(this.selectedLocationForFilter)
      this.selectedLocationForFilter = locationData

      const locationTag = document.getElementById('locationFilterSelectedLocationTag')
      locationTag.textContent = GENRALHELPERS._getDisplayLocationName(locationData)

      this.#locationDataForFilter.lat = locationData.lat
      this.#locationDataForFilter.lng = locationData.lng

      console.log('LocationData', locationData, this.#locationDataForFilter);


    } catch (error) {
      console.log(error);

      if (error === 'cancelled') {
        if (!this.selectedLocationForFilter?.address) {
          alert("Nesecitas seleccionar una ubicación para poder filtrar 'Cerca de mi'")
        }
      }
    }
  }

  async _events() {
    if (this.#alreadlyInitialized) return;
    const buttonToScrollToTop = document.getElementById('homeScreenDisplayInitialScreenScrollButtonScrollTop')

    buttonToScrollToTop.addEventListener('click', () => {
      this._scrollToTop('homeScreenDisplayInitialScreenScroll')
    })

    this._observeElementTopVisibility('initScreenCon3', (view) => {
      const button = document.getElementById('homeScreenDisplayInitialScreenScrollButtonScrollTop')
      if (view) {
        console.log(view);
        // button.classList.remove('initScreenButtonScrollTopCon1Translate10Px')
        button.classList.add('initScreenButtonScrollTopCon1Translate100')
      } else {
        console.log(view);
        button.classList.remove('initScreenButtonScrollTopCon1Translate100')
        button.classList.add('initScreenButtonScrollTopCon1Translate10Px')
      }
    })

    this._detectScrollActivity(
      "homeScreenDisplayInitialScreenScroll",

      // 🚀 scrolling started
      () => {
        const button = document.getElementById(
          "homeScreenDisplayInitialScreenScrollButtonScrollTop"
        );

        button.classList.add("initScreenButtonScrollTopCon1Translate10Px");
      },

      // 🛑 scrolling stopped
      () => {
        const button = document.getElementById(
          "homeScreenDisplayInitialScreenScrollButtonScrollTop"
        );

        button.classList.remove("initScreenButtonScrollTopCon1Translate10Px");
      }
    );


    // const HomeScreenButtonCreateListing = document.getElementById(
    //   "HomeScreenButtonCreateListing"
    // );
    window.addEventListener("click", async (e) => {
      if (e.target.closest(".model1AddButtonClose")) {
        const parentAdd = e.target.closest(".model1AddCon1")

        if (parentAdd) {
          parentAdd.remove()
        }

      }


      if (e.target.closest("#HomeScreenButtonCreateListing")) {
        console.log("create lisitng called");
        CreateListing._init();
      }
      if (e.target.closest("#HomeScreenButtonCreateListingFloating")) {
        console.log("create listing called");
        CreateListing._init();
      }



      if (e.target.closest("#HomeScreenButtonHelp")) {
        console.log("create listing called");
        help._open();
        // CreateListing._init();
      }
      if (e.target.closest("#HeaderConWellcomeWithName")) {
        // accountProfileChange._open();
        signUpProfile._open();
      }
      if (e.target.dataset.generall === "expandforviewall") {
        console.log("here");
        const parent = e.target.closest(".ListingPackDisplayCon1");
        const parentCon2 = parent.querySelector(".ListingPackDisplayCon3");
        const lastChild = parentCon2.lastElementChild; // Get the last child
        console.log(lastChild);
        if (lastChild) {
          parentCon2.scrollTo({
            left: lastChild.offsetLeft - parentCon2.offsetLeft, // Scroll to the last child's position
            behavior: "smooth", // Enable smooth scrolling
          });
        }

        // child.classList.toggle("VIEW-ALL-CLASS");
      }
      if (e.target.dataset.generall === "viewMore") {
        console.log("here");
        const parent = e.target.closest(".ListingPackDisplayCon1");
        const HomeScreenContenConForSeachAndAdd = document.getElementById(
          "MainAppConWithNavigationContentConHome"
        );
        const parentCon2 = parent.querySelector(".ListingPackDisplayCon3");
        const lastChild = parentCon2.lastElementChild; // Get the last child

        console.log(lastChild);

        if (lastChild) {
          HomeScreenContenConForSeachAndAdd.scrollTo({
            top:
              lastChild.offsetTop -
              parentCon2.offsetTop +
              lastChild.clientHeight,
            behavior: "smooth",
          });
        }

        // child.classList.toggle("VIEW-ALL-CLASS");
      }
      if (e.target.dataset.generall === "expandforviewallEditMode") {
        const parent = e.target.closest(".OwnBusinessListingsCon2");
        const parentCon2 = parent.querySelector(".OwnBusinessListingsCon4");
        const lastChild = parentCon2.lastElementChild; // Get the last child

        if (lastChild) {
          parentCon2.scrollTo({
            left: lastChild.offsetLeft - parentCon2.offsetLeft, // Scroll to the last child's position
            behavior: "smooth", // Enable smooth scrolling
          });
        }
      }
      if (e.target.dataset.generall === "expandforviewallbusiness") {
        const parent = e.target.closest(".BusinessesPackDisplayCon1");
        const parentCon2 = parent.querySelector(".BusinessesPackDisplayCon3");
        const lastChild = parentCon2.lastElementChild; // Get the last child

        if (lastChild) {
          parentCon2.scrollTo({
            left: lastChild.offsetLeft - parentCon2.offsetLeft, // Scroll to the last child's position
            behavior: "smooth", // Enable smooth scrolling
          });
        }
      }
    });
    window.addEventListener("click", (e) => {
      const help = e.target.closest(".openHelp");

      if (help) {
        const helpWith = help.dataset.helpwith;
      }
    });

    const locationFilterTagButtonOpenLocation = document.getElementById(
      "locationFilterTagButtonOpenLocation"
    );
    const locationFilterButtonOpenLocation = document.getElementById(
      "locationFilterButtonOpenLocation"
    );
    const locationFilterButtonCloseFilter = document.getElementById(
      "locationFilterButtonCloseFilter"
    );
    const locationFilterButtonAplyFilter = document.getElementById(
      "locationFilterButtonAplyFilter"
    );
    const locationFilterOpenerCon = document.getElementById(
      "locationFilterOpenerCon"
    );
    locationFilterButtonCloseFilter.addEventListener("click", () => {
      this._closeLocationFilter();
    });
    locationFilterButtonAplyFilter.addEventListener("click", () => {
      this.#locationFilterTrigerFunctions.applyFilter(this.#locationDataForFilter);
      console.log('this.#locationDataForFilter', this.#locationDataForFilter);
    });
    locationFilterOpenerCon.addEventListener("click", () => {
      this._openLocationFilter();
    });
    locationFilterButtonOpenLocation.addEventListener("click", async () => {
      this._handleSelectLocationForFilter()
    });
    locationFilterTagButtonOpenLocation.addEventListener("click", async () => {
      this._handleSelectLocationForFilter()
    });


    const SearchStartUpComponentSearchInput = document.getElementById(
      "SearchStartUpComponentSearchInput"
    );

    const homeScreenDisplayAllButtonCloseSearch = document.getElementById(
      "homeScreenDisplayAllButtonCloseSearch"
    );
    homeScreenDisplayAllButtonCloseSearch.addEventListener("click", (e) => {
      const close = homeScreenDisplayAllButtonCloseSearch.dataset.close

      console.log(close);

      if (close) {
        if (close === 'location') {
          this._closeLocationFilter();
        }
        if (close === 'search') {
          this._closeSearch();
        }
      }
    });
    SearchStartUpComponentSearchInput.addEventListener("focus", () => {
      this._openSearch();
    });


    const initKmSelector = (containerSelector) => {
      let currentLocationRadius = '10'
      const container = document.getElementById(containerSelector);
      const items = Array.from(container.querySelectorAll('.locationFilterKmCon7'));

      const updateActive = () => {
        const containerRect = container.getBoundingClientRect();
        const centerY = containerRect.top + containerRect.height / 2;

        let closestItem = null;
        let closestDistance = Infinity;

        items.forEach(item => {
          const rect = item.getBoundingClientRect();
          const itemCenter = rect.top + rect.height / 2;
          const distance = Math.abs(centerY - itemCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestItem = item;
          }
        });

        items.forEach(item => item.classList.remove('active'));

        if (closestItem) {
          closestItem.classList.add('active');

          // ✅ log selected km
          const km = closestItem.dataset.km
          if (currentLocationRadius !== km) {
            currentLocationRadius = km
            this.#locationDataForFilter.radius = Number(km)
          }
        }
      }

      // Run on scroll
      container.addEventListener('scroll', updateActive);

      // Run once on init
      updateActive();


    }
    initKmSelector('locationFilterKmCon5');


  }

  _clearContainer() {
    const HomeScreenContenConForAll = document.getElementById(
      "MainAppConWithNavigationContentConHome"
    );
    HomeScreenContenConForAll.innerHTML = "";
  }

  //

  //

  _displayRightNavWindow() {
    const windows = document.querySelectorAll(
      ".MainAppConWithNavigationContentCon"
    );

    windows.forEach((window) => {
      if (window.id === "MainAppConWithNavigationContentConHome") {
        window.style.display = "";
      } else {
        window.style.display = "none";
      }
    });
  }


  _screensSwitch(initial = true) {
    const homeScreenDisplayAll = document.getElementById("homeScreenDisplayAll");
    const homeScreenDisplayInitialScreen = document.getElementById("homeScreenDisplayInitialScreen");

    if (initial) {
      homeScreenDisplayAll.style.display = "none";
      homeScreenDisplayInitialScreen.style.display = "flex"
      this.#isInitScreen = true
      nav._show(false);
    } else {
      homeScreenDisplayAll.style.display = "flex";
      homeScreenDisplayInitialScreen.style.display = "none";
      this.#isInitScreen = false
      nav._hide(true);
    }

  }

  async _init(init) {
    if (this.#alreadlyInitialized && !init) {
      allHandeling._scrollToTopOfCurrentCategory()

    } else {
      this.#accountState = firebase._getLatestCurrentUserData();
      this._clearContainer();
      this._inserntSearchComponent();
      AllDisplaysInitial._init();
      this._events();
      nav._initNavObserver();
      this._displayRightNavWindow();
      this.#alreadlyInitialized = true;

      this._screensSwitch(true)
      this._navigateFromInitScreenInit()
      this._startGetLoop(10, true)
      // this._setTopAdds()
    }
    this._displayRightNavWindow()
    maiTips._initTips()


  }



  _makeAddSetToInsert() {
    return ''
    let adds = ``

    topAdds.forEach(add => {
      const html = generateHtml._initScreenAdd(add)
      adds += html
    })

    const addSet = generateHtml._addContainerM1(adds)

    return addSet
  }


  _setTopAdds() {
    return
    const initScreenInsertTopAdds = document.getElementById('initScreenInsertTopAdds')

    initScreenInsertTopAdds.classList.remove('initScreenCon6NoAdds')

    topAdds.forEach(add => {

      const html = generateHtml._initScreenAdd(add)

      initScreenInsertTopAdds.insertAdjacentHTML('beforeend', html)
    })


    window.addEventListener('click', (e) => {
      const target = e.target.closest('[data-openlink]');
      if (target) {
        const openLink = target.dataset.openlink;

        GENRALHELPERS._openOutboundLink(openLink)
      }
    });
  }

  async _startGetLoop(maxListings = 10, reset) {

    // 🔥 BLOCK immediately
    if (!this.#isDoneLoadingListings) return;
    if (this.#allListingsLoaded) return;

    this.#isDoneLoadingListings = false;

    if (reset) {
      this.#listingsLastVisDoc = null;
      this.#allListingsLoaded = false;
    }

    try {
      const { listings, lastVisibleDoc } =
        await firebase._getMostRecentListingsWithOutFilterGlobal(
          this.#listingsLastVisDoc,
          maxListings
        );

      if (!listings || listings.length === 0) {
        this.#allListingsLoaded = true;
        return;
      }

      console.log(listings);

      this._fillListings(listings, reset);
      this.#listingsLastVisDoc = lastVisibleDoc;

    } finally {
      // ✅ UNLOCK after everything is done
      this.#isDoneLoadingListings = true;
      this._activateDetectScrollToBottomListings(100);
    }
  }
  async _fillListings(listings, reset) {
    const ListingsContianer = document.getElementById(
      "initScreenInsertListings"
    );
    if (reset) {
      ListingsContianer.innerHTML = "";
    }
    for (const listing of listings) {
      let html = displayListingGenerateHtml._listingVerticalNV(listing);

      ListingsContianer.insertAdjacentHTML(
        "beforeend",
        html
      );
    }

    const addSet = this._makeAddSetToInsert();
    ListingsContianer.insertAdjacentHTML(
      "beforeend",
      addSet
    );

  }

  _activateDetectScrollToBottomListings = (margin = 0) => {
    if (this.#detectBottomScrollListingnsOn) return;
    this.#detectBottomScrollListingnsOn = true;

    const reuseFunction = (id) => {
      const container = document.getElementById(id);
      if (!container) {
        console.log("Error: Container not found.");
        return;
      }

      // Add a scroll event listener
      container.addEventListener("scroll", async () => {
        if (!this.#isDoneLoadingListings) return;
        const isScrolledToBottom =
          container.scrollHeight -
          container.scrollTop -
          container.clientHeight <=
          margin;

        if (isScrolledToBottom) {
          this._startGetLoop(10)
        }
      });
    }
    reuseFunction('homeScreenDisplayInitialScreenScroll')
  }


  _navigateFromInitScreenInit() {
    const initScreenOpenSearch = document.getElementById('initScreenOpenSearch')
    const initScreenOpenListings = document.getElementById('initScreenOpenListings')
    const initScreenOpenBusinesses = document.getElementById('initScreenOpenBusinesses')
    const initScreenOpenSellers = document.getElementById('initScreenOpenSellers')
    const homeScreenDisplayAllButtonBack = document.getElementById('homeScreenDisplayAllButtonBack')

    const homeScreenLocationFilterCtaCon2 = document.getElementById(
      "homeScreenLocationFilterCtaCon2"
    );
    const homeScreenUploadCtaCon2 = document.getElementById(
      "homeScreenUploadCtaCon2"
    );

    homeScreenLocationFilterCtaCon2.addEventListener("click", async () => {
      this._screensSwitch(false)
      allHandeling._setActiveCategory('listings', 'locationFilter')


      // setTimeout(() => {
      //   this._openLocationFilter();
      // }, 500);
    });
    homeScreenUploadCtaCon2.addEventListener("click", async () => {
      createListing._init()
    });

    initScreenOpenSearch.addEventListener('click', () => {
      this._screensSwitch(false)
      allHandeling._setActiveCategory('listings', 'search')

    })
    initScreenOpenListings.addEventListener('click', () => {
      this._screensSwitch(false)
      allHandeling._setActiveCategory('listings', 'all')

    })
    initScreenOpenBusinesses.addEventListener('click', () => {
      this._screensSwitch(false)
      allHandeling._setActiveCategory('businesses')

    })
    initScreenOpenSellers.addEventListener('click', () => {
      this._screensSwitch(false)
      allHandeling._setActiveCategory('indsellers')

    })
    homeScreenDisplayAllButtonBack.addEventListener('click', () => {
      this._screensSwitch(true)
      const buttonScrollTop = document.getElementById("homeScreenDisplayInitialScreenScrollButtonScrollTop");
      buttonScrollTop.style.display = "flex";
    })
  }


  _openSearch() {
    let text = 'Buscando en "Listados"';


    const currentCat = allHandeling._getCurrentCategory()
    if (currentCat === "listings") {
      text = 'Buscando en "Listados"'
    }
    if (currentCat === "businesses") {
      text = 'Buscando en "Negocios"'
    }
    if (currentCat === "indsellers") {
      text = 'Buscando en "Vendedores"'
    }

    const homeHeaderSearchCon10A = document.getElementById(
      "homeHeaderSearchCon10A"
    );
    const HomeScreenButtonCreateListing = document.getElementById(
      "HomeScreenButtonCreateListing"
    );
    const SearchStartUpComponentSearchInputIcon = document.getElementById(
      "SearchStartUpComponentSearchInputIcon"
    );
    const HomeScreenCon3 = document.getElementById("HomeScreenCon3");
    const homeHeaderSearchCon13 = document.getElementById(
      "homeHeaderSearchCon13"
    );
    const SearchStartUpComponentSearchInput = document.getElementById(
      "SearchStartUpComponentSearchInput"
    );
    const homeHeaderSearchCon10 = document.getElementById(
      "homeHeaderSearchCon10"
    );

    const homeHeaderSearchCatCon = document.getElementById(
      "homeHeaderSearchCatCon"
    );
    const homeHeaderSearchCon9 = document.getElementById(
      "homeHeaderSearchCon9"
    );
    const nvHeaderCon2BigAddContainer = document.getElementById(
      "nvHeaderCon2BigAddContainer"
    );
    const homeScreenDisplayAllButtonBack = document.getElementById(
      "homeScreenDisplayAllButtonBack"
    );
    const homeScreenDisplayAllButtonCloseSearch = document.getElementById(
      "homeScreenDisplayAllButtonCloseSearch"
    );

    SearchStartUpComponentSearchInputIcon.style.display = "none";
    homeScreenDisplayAllButtonBack.style.display = "none";
    homeScreenDisplayAllButtonCloseSearch.style.display = "flex";
    homeScreenDisplayAllButtonCloseSearch.dataset.close = "search";
    homeHeaderSearchCon10.classList.add("homeHeaderSearchCon10Act");
    SearchStartUpComponentSearchInput.classList.add(
      "SearchStartUpComponentCon5InputAct"
    );

    adds._hideDispBigVideoAdd('hide')
    HomeScreenButtonCreateListing.style.display = "none";
    homeHeaderSearchCon10A.classList.remove("homeHeaderSearchCon10APaddingLeft");

    homeHeaderSearchCatCon.style.display = "none";
    nav._hide();
    allHandeling._startSearch();
  }
  _closeSearch() {
    const homeHeaderSearchCon10A = document.getElementById(
      "homeHeaderSearchCon10A"
    );
    const HomeScreenButtonCreateListing = document.getElementById(
      "HomeScreenButtonCreateListing"
    );
    const SearchStartUpComponentSearchInputIcon = document.getElementById(
      "SearchStartUpComponentSearchInputIcon"
    );
    const SearchStartUpComponentSearchInput = document.getElementById(
      "SearchStartUpComponentSearchInput"
    );
    const homeHeaderSearchCon10 = document.getElementById(
      "homeHeaderSearchCon10"
    );
    const homeHeaderSearchCatCon = document.getElementById(
      "homeHeaderSearchCatCon"
    );
    const homeScreenDisplayAllButtonBack = document.getElementById(
      "homeScreenDisplayAllButtonBack"
    );
    const homeScreenDisplayAllButtonCloseSearch = document.getElementById(
      "homeScreenDisplayAllButtonCloseSearch"
    );
    homeScreenDisplayAllButtonBack.style.display = "flex";
    homeScreenDisplayAllButtonCloseSearch.style.display = "none";


    SearchStartUpComponentSearchInput.value = "";
    homeHeaderSearchCon10.classList.remove("homeHeaderSearchCon10Act");
    SearchStartUpComponentSearchInput.classList.remove(
      "SearchStartUpComponentCon5InputAct"
    );
    SearchStartUpComponentSearchInputIcon.style.display = "flex";
    HomeScreenButtonCreateListing.style.display = "flex";
    homeHeaderSearchCon10A.classList.add("homeHeaderSearchCon10APaddingLeft");


    homeHeaderSearchCatCon.style.display = "flex";

    nav._show();
    allHandeling._endSearch();
    adds._hideDispBigVideoAdd('show')
  }

  _openLocationFilter() {
    const homeHeaderSearchCatCon = document.getElementById("homeHeaderSearchCatCon");
    const homeHeaderSearchCon10A = document.getElementById("homeHeaderSearchCon10A");
    const homeScreenDisplayAllButtonCloseSearch = document.getElementById("homeScreenDisplayAllButtonCloseSearch");

    const homeScreenDisplayAllButtonBack = document.getElementById("homeScreenDisplayAllButtonBack");
    const homeHeaderSearchCon10 = document.getElementById("homeHeaderSearchCon10");

    const locationFilterAdjCon = document.getElementById("locationFilterAdjCon");
    const locationFilterOpenerCon = document.getElementById("locationFilterOpenerCon");


    locationFilterAdjCon.style.display = "flex";
    locationFilterOpenerCon.style.display = "none";

    homeHeaderSearchCatCon.style.display = "none";
    homeScreenDisplayAllButtonCloseSearch.style.display = "none";
    homeScreenDisplayAllButtonCloseSearch.dataset.close = "location";


    homeHeaderSearchCon10A.style.display = "none";

    this.#locationFilterTrigerFunctions = allHandeling._startLocationFilter()

    // SearchStartUpComponentSearchInputIcon.style.display = "none";
    // SearchStartUpComponentSearchInput.classList.add(
    //   "SearchStartUpComponentCon5InputAct"
    // );

    // adds._hideDispBigVideoAdd('hide')
    // HomeScreenButtonCreateListing.style.display = "none";

    // nav._hide();
    // allHandeling._startSearch();
  }
  _closeLocationFilter() {
    const homeHeaderSearchCatCon = document.getElementById("homeHeaderSearchCatCon");
    const homeScreenDisplayAllButtonCloseSearch = document.getElementById("homeScreenDisplayAllButtonCloseSearch");
    const homeScreenDisplayAllButtonBack = document.getElementById("homeScreenDisplayAllButtonBack");
    const homeHeaderSearchCon10 = document.getElementById("homeHeaderSearchCon10");
    const homeHeaderSearchCon10A = document.getElementById("homeHeaderSearchCon10A");

    const locationFilterAdjCon = document.getElementById("locationFilterAdjCon");
    const locationFilterOpenerCon = document.getElementById("locationFilterOpenerCon");


    locationFilterAdjCon.style.display = "none";
    locationFilterOpenerCon.style.display = "flex";


    homeHeaderSearchCatCon.style.display = "flex";
    homeHeaderSearchCon10A.style.display = "flex";
    homeScreenDisplayAllButtonCloseSearch.style.display = "none";


    // nav._show();

    allHandeling._endLocationFilter()

    // adds._hideDispBigVideoAdd('show')
  }

  _inserntSearchComponent() {
    const HomeScreenContenConForSeachAndAdd = document.getElementById(
      "MainAppConWithNavigationContentConHome"
    );

    HomeScreenContenConForSeachAndAdd.innerHTML = "";

    const topToolsSetterComponent = generateHtml._topToolsSetter();
    HomeScreenContenConForSeachAndAdd.insertAdjacentHTML(
      "beforeend",
      topToolsSetterComponent
    );
    // allHandeling._startInitialLoading();
    allHandeling._setActiveCategory('listings')
  }
}
export default new HomeScreen();
